import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  creditDecisionGranted: { id: 'creditDecision.decision.granted', defaultMessage: 'Granted' },
  creditDecisionDenied: { id: 'creditDecision.decision.declined', defaultMessage: 'Declined' },
  creditDecisionMissing: { id: 'creditDecision.decision.missing', defaultMessage: 'No decision' },
  creditDecisionLabel: { id: 'creditDecision.label', defaultMessage: 'Credit decision:' },
})
